import { combineReducers } from 'redux';

import byId from './byId';
import select from './select';

/**
 * @typedef {{
 *  byId: import('./byId').UserDataByIdReducer,
 *  select: import('./select').UserDataSelectReducer,
 * }} UserDataReducer
 */

export default combineReducers({
  byId,
  select,
});
